import { IntegrationCreatePanelWebComponent } from './component/IntegrationCreatePanelWebComponent';
import { WEB_COMPONENT_INTEGRATION_CREATE_PANEL } from '../../webcomponents.constants';

export { IntegrationCreatePanelWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRATION_CREATE_PANEL, IntegrationCreatePanelWebComponent);
